import { wrapRootElement, createOnClientEntry } from './src/shared/gatsby/browser-utils'

export { wrapRootElement }

export const onClientEntry = createOnClientEntry()